import { createPortal } from 'react-dom';
import { CustomThemeProvider, usePortal } from 'sonata-react-components';

import type { ReactNode } from 'react';

/** Renders grouping modals/prompts at the end of <body> (above the map sidebar) with the light theme. */
export function GroupingPortal({ children }: Readonly<{ children: ReactNode }>) {
  const target = usePortal('groupItemsModal');
  return createPortal(<CustomThemeProvider themeContrast="light">{children}</CustomThemeProvider>, target);
}
